import * as React from 'react'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import { isAdmin, isManager, isProducer } from 'web-fns/dist/auth'

import EnvironmentContext from '../../../../components/EnvironmentContext/EnvironmentContext'
import { isCurrentPage } from '../../../../helpers/pageLocationHelper'

import { BrandSettinsHeader } from '../../BrandDashboardSettings/BrandDashboardSettings.style'

import DefaultButton from '../DefaultButton/DefaultButton'

import { Wrapper, Separator, SubHeaderNav } from './SubHeader.style'
import { Route } from 'react-router-dom'
interface SubHeaderProps {
  title: string
  subHeaderChildren: React.ReactNode | any
  isSubHeaderHidden?: boolean
  urlBrandId?: string
  activeMenu?: number
  isNavCollapsed?: boolean
}

const SubHeader: React.FC<SubHeaderProps> = ({
  activeMenu,
  title,
  subHeaderChildren,
  isSubHeaderHidden,
  urlBrandId,
  isNavCollapsed,
}) => {
  const { GEN1_BASE_URL } = React.useContext(EnvironmentContext) || ''
  const isAdminUser = isAdmin() || isProducer() || isManager()

  const brandSettingsHeader = (
    <BrandSettinsHeader>
      <DefaultButton
        fontSize="0.875rem"
        padding="0 1rem"
        backgroundColor="white"
        borderColor={colors.black1}
        color={colors.black1}
        buttonHeight="2.75rem"
        rounded
        hoverBackground={colors.black1}
        hoverColor="white"
        style={{ borderWidth: '2px' }}
        onClick={() => {
          window.open(`${GEN1_BASE_URL}/organisations/${urlBrandId}/brand_assets`, '_blank')
        }}
      >
        Manage brand assets
      </DefaultButton>
      {isAdminUser && (
        <DefaultButton
          fontSize="0.875rem"
          padding="0 1.25rem"
          backgroundColor={colors.adaptBlue}
          buttonHeight="2.75rem"
          rounded
          hoverBackground={colors.adaptBlue}
          hoverColor="white"
          style={{ borderWidth: '2px' }}
          onClick={() => {
            window.open(`${GEN1_BASE_URL}/organisations/${urlBrandId}/account_products`, '_blank')
          }}
        >
          Brand management
        </DefaultButton>
      )}
    </BrandSettinsHeader>
  )

  const subHeaderNavItems = [
    {
      label: 'Settings',
      href: `/brand-dashboard/settings/${urlBrandId}`,
      isActive: activeMenu === 4,
      isExternal: false,
    },
    {
      label: 'My Team',
      href: `/brand-dashboard/team/${urlBrandId}`,
      isActive: activeMenu === 5,
      isExternal: false,
    },
    {
      label: 'Billing',
      href: `${GEN1_BASE_URL}/organisations/${urlBrandId}/account`,
      isActive: activeMenu === 6,
      isExternal: true,
    },
    {
      label: 'My Enterprise',
      href: `/brand-dashboard/sub-brands/${urlBrandId}`,
      isActive: activeMenu === 7,
      isExternal: false,
    },
    {
      label: 'Wallets',
      href: `/brand-dashboard/wallets/${urlBrandId}`,
      isActive: activeMenu === 3,
      isExternal: false,
    },
  ]
  // const bodyClass = document.body.className.replace(/\s+/g, '_').toLowerCase()

  const subHeaderNav = (
    <SubHeaderNav>
      <ul key={`${title.replace(/ /g, '_')}-sub-header-nav`}>
        {subHeaderNavItems.map(
          (item, index) =>
            item.isExternal ? (
              <li
                key={`${item.label.replace(/ /g, '_')}-${index}`}
                className={item.isActive ? 'active' : ''}
              >
                <a href={item.href}>{item.label}</a>
              </li>
            ) : (
              <Route
                render={({ history }) => (
                  <li
                    key={`${item.label.replace(/ /g, '_')}-${index}-test`}
                    onClick={() => history.push(item.href)}
                    className={item.isActive ? 'active' : ''}
                  >
                    {item.label}
                  </li>
                )}
              />
            )
        )}
      </ul>
    </SubHeaderNav>
  )

  return (
    <Wrapper isSubHeaderHidden={!!isSubHeaderHidden} isNavCollapsed={isNavCollapsed}>
      <div>
        <h2>{title}</h2>
        <Separator />
        {!isCurrentPage('brand-dashboard/orders/') && subHeaderNav}
        {subHeaderChildren}
      </div>
      {isCurrentPage('brand-dashboard/settings/') && brandSettingsHeader}
    </Wrapper>
  )
}

export default SubHeader



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/SubHeader/SubHeader.tsx